<div>
  @for (data of detailViewData; track data) {
    <app-generic-card (actionClick)="openDialog($event)" [config]="data.cardConfig"></app-generic-card>
  }
</div>


